import React, { ReactNode } from 'react';
import NavigationBar from '../NavigationBar/NavigationBar';
import { isInNativeTab } from '../../utils/nativeTab';
import './Layout.css';

interface Props {
  children: ReactNode;
}

const Layout: React.FC<Props> = ({ children }) => {
  return (
    <div className="min-h-screen">
      <NavigationBar hideAccessButton={isInNativeTab()} isNativeTab={isInNativeTab()} />
      <main className="pt-14">
        <div className="container mx-auto px-4 py-6 animate-fade-in-up">
          {children}
        </div>
      </main>
    </div>
  );
};

export default Layout;
